import { useEffect } from "react";
import { api } from "../utils/api";
import auth from "../utils/auth";
import { clearRef, getRef, INVITE_ENABLED } from "../utils/referral";

/**
 * 초대 링크로 들어와 카카오·구글 등으로 가입한 회원: 로그인되면 기억해 둔 초대 번호를 서버에 한 번 보낸다.
 * 서버가 새 회원(가입 3일 안)·추천인 빈 칸일 때만 붙이고, 아니면 무시한다 (api ReferralController@claim).
 */
const ReferralClaim = () => {
  useEffect(() => {
    const ref = getRef();
    if (!INVITE_ENABLED || !ref || !auth.getToken()) return;
    api.post("/referral/claim", { ref })
      .then(({ data }) => { if (data && data.success) clearRef(); })
      .catch(() => null);
  }, []);
  return null;
};

export default ReferralClaim;
